'use client';

import { c as _c } from "react/compiler-runtime";
import Modal from '@/components/atoms/Modal';
import { Crosshair } from '@/components/atoms/Icons';
import { useExplore } from './ExploreProvider';

/**
 * Modal displayed when location services are denied.
 * Instructs users to enable location in browser settings.
 */
export function LocationDeniedModal() {
  const $ = _c(6);
  const {
    locationPermission,
    setLocationPermission
  } = useExplore();
  const isOpen = locationPermission === "denied";
  let t0;
  if ($[0] !== setLocationPermission) {
    t0 = () => {
      if (typeof window !== "undefined") {
        localStorage.setItem("locationModalDismissed", "true");
      }
      setLocationPermission("dismissed");
    };
    $[0] = setLocationPermission;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClose = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pt-4 text-center"><div className="flex justify-center mb-4"><Crosshair className="h-8 w-8" /></div><h2 className="text-xl lg:text-[26px] font-semibold text-[#323232] mb-4 max-w-[205px] mx-auto leading-[1.07]">Location Access Turned Off</h2><p className="text-[#626262] mb-6 text-base">It looks like location access is turned off for this site. To see your current location on the map and find nearby Hearts and promotions, please enable location services in your browser settings.</p></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handleClose || $[4] !== isOpen) {
    t2 = <Modal isOpen={isOpen} onClose={handleClose} ariaLabel="Location access denied" className="md:max-w-md max-w-full">{t1}</Modal>;
    $[3] = handleClose;
    $[4] = isOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}